<template>
  <div class="d-flex flex-column sticky-footer-wrapper">
    <main class="flex-fill">
      <fab-to-up/>
      <fab-to-whatsapp/>
      <app-header></app-header>
      <message-component></message-component>
      <div class="container mt-3">
        <div class="row">
          <div class="col-md-12">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Header from "./components/Header.vue";
import FabToUp from "./components/FabToUp.vue";
import FabToWhatsapp from "./components/FabToWhatsapp.vue";
import { getParamsApi } from "@/api/modules";
import MessageComponent from "./components/common/MessageComponent.vue";
export default {
  components: {
    appHeader: Header,
    MessageComponent,
    FabToUp,
    FabToWhatsapp
  },
  created() {
    window.getApp = this;
    this.getParams()
  },
  methods: {
    ...mapActions(["setPhoneNumber", "setRate"]),
    async getParams() {
      let serviceResponse = await getParamsApi();
      if (serviceResponse.status) {
        localStorage.percentFee = serviceResponse.data.percentFee;
        localStorage.usdMinimalDelivery = serviceResponse.data.usdMinimalDelivery;
        this.setPhoneNumber(serviceResponse.data.phoneNumber) //Saving on vuex, to be reactive
        this.setRate(serviceResponse.data.usdRate) //Saving on vuex, to be reactive
      } else {
        setTimeout(this.getParams, 10000) //Try again in 10 seconds
      }
    }
  }
};
</script>

<style>
#reset-store-panel {
  position: fixed;
  bottom: 0px;
  right: 0px;
}

body,
.sticky-footer-wrapper {
  min-height: 100vh;
}

.flex-fill {
  flex: 1 1 auto;
}
footer {
  height: 40px;
  color: #666;
  padding: 10px 0 10px 0;
  font-size: 85%;
}
footer a {
  color: #999;
}
footer a:hover {
  color: #efefef;
}
@media (max-width: 576px) {
  footer {
    height: 50px;
  }
}
</style>
